import Reveal from "@/components/Reveal";

export const Chef = ({ content }) => {
  const c = content || {};
  const stats = c.stats || [];

  return (
    <section id="chef" data-testid="chef-section" className="relative bg-transparent py-24 md:py-36">
      <div className="sm-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <Reveal className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={c.image_url}
                alt={c.name}
                data-testid="chef-portrait"
                className="absolute inset-0 w-full h-full object-cover grayscale-[15%] transition-transform duration-[2000ms] hover:scale-[1.04]"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-sm-bg border border-sm-border px-6 py-4 hidden md:block">
              <p className="font-serif italic text-sm-text text-lg">{c.name}</p>
              <p className="text-[0.65rem] tracking-[0.32em] uppercase text-sm-olive mt-1">
                {c.role}
              </p>
            </div>
          </Reveal>

          <div className="lg:col-span-7 lg:pl-8">
            <Reveal>
              <p className="sm-eyebrow" data-testid="chef-eyebrow">
                {c.eyebrow}
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                data-testid="chef-title"
                className="font-serif text-4xl md:text-5xl lg:text-6xl text-sm-text mt-6 leading-[1.05]"
              >
                <span className="italic font-light">{c.title_line_1}</span>
                <br />
                <span className="italic font-light">{c.title_line_2}</span>
              </h2>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="sm-divider mt-12 mb-10 max-w-[120px]" />
            </Reveal>

            <Reveal delay={0.25}>
              <p
                data-testid="chef-bio-1"
                className="text-base md:text-lg text-sm-muted leading-[1.85] font-light whitespace-pre-line"
              >
                {c.bio_1}
              </p>
            </Reveal>

            <Reveal delay={0.35}>
              <p
                data-testid="chef-bio-2"
                className="mt-6 text-base md:text-lg text-sm-muted leading-[1.85] font-light whitespace-pre-line"
              >
                {c.bio_2}
              </p>
            </Reveal>

            {stats.length > 0 && (
              <Reveal delay={0.5}>
                <div className="mt-14 grid grid-cols-3 gap-8 max-w-md">
                  {stats.slice(0, 3).map((s, i) => (
                    <div key={i}>
                      <p className="font-serif text-3xl text-sm-olive">{s.value}</p>
                      <p className="text-[0.65rem] tracking-[0.28em] uppercase text-sm-muted mt-2">
                        {s.label}
                      </p>
                    </div>
                  ))}
                </div>
              </Reveal>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Chef;
